import { Popover } from "@mui/material";
import RedDotNotificationicon from "../../assets/common/notification-red-dot-icon.svg";
import DefaultNotificationIcon from "../../assets/common/default-notification-icon.svg";
import "../../styles/app-notification.css";
import { useState, useRef, ReactNode, useEffect } from "react";
import React from "react";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";

interface AppNotificationProps {
  contentComponent: ReactNode;
  notificationCount: number;
  notificationApiRefetch?: (options?: RefetchOptions) => Promise<QueryObserverResult<any, any>>
}
const AppNotification = ({ contentComponent, notificationCount, notificationApiRefetch }: AppNotificationProps) => {
  const [openPopup, setOpenPopup] = useState(false);
  const iconRef = useRef<HTMLDivElement | null>(null);
  const getNotificationIcon = () => {
    return Number(notificationCount) > 0 ? (
      <img
        src={RedDotNotificationicon}
        alt="notification"
        className="notification_icon red-dot-icon"
      />
    ) : (
      <img
        src={DefaultNotificationIcon}
        alt="notification"
        className="notification_icon default-icon"
      />
    );
  };    
  useEffect(()=>{
    if(!openPopup){
      notificationApiRefetch?.();
    }
  },[openPopup])

  return (
    <div className="appnotification__container">

      {/* Notification icon */}
      <div
        className={`notification_icon_wrapper
          ${Number(notificationCount) > 0 ? "has-notification" : ""}
          ${openPopup ? "active" : ""}
        `}
        ref={iconRef}
        onClick={() => setOpenPopup(true)}
      >
        {getNotificationIcon()}
      </div>

      {/* Popover */}
      <Popover
        open={openPopup}
        anchorEl={iconRef.current}
        onClose={() => setOpenPopup(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ className: "notification_popover" }}
      >
        {React.cloneElement(contentComponent as React.ReactElement, {
          onClose: () => setOpenPopup(false),
        })}
      </Popover>
    </div>
  );
};

export default AppNotification;
